import Textarea from "@/modules/common/components/input/text-area";
import { ListingDescriptionFormFields } from "@/modules/property-tracks/utils/listing";
import { Box, Typography } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";

export default function ListingDescriptionForm({
  form,
}: {
  form: UseFormReturn<ListingDescriptionFormFields>;
}) {
  return (
    <Box
      sx={(t) => ({
        display: "flex",
        flexDirection: "column",
        gap: t.nawy.spacing.md,
      })}
    >
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
      >
        Unit descrption
      </Typography>

      <Controller
        control={form.control}
        name={"descriptionAr"}
        render={({ field, fieldState }) => (
          <Textarea
            {...field}
            label="AR Description"
            placeholder="Write your arabic description here"
            isError={!!fieldState.error}
            errorMsg={fieldState.error?.message}
          />
        )}
      ></Controller>
      <Controller
        control={form.control}
        name={"descriptionEn"}
        render={({ field, fieldState }) => (
          <Textarea
            {...field}
            label="EN Description"
            placeholder="Write your english description here"
            isError={!!fieldState.error}
            errorMsg={fieldState.error?.message}
          />
        )}
      ></Controller>
    </Box>
  );
}
